import { Component, OnInit } from '@angular/core';
import { UserListingModel, UserResponseModel } from 'src/app/models/user/userListing.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { UserService } from 'src/app/services/user.service';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeUserPasswordComponent } from '../change-user-password/change-user-password.component';
import { UpdateUserComponent } from '../update-user/update-user.component';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';

@Component({
  selector: 'app-user-listing',
  templateUrl: './user-listing.component.html',
  styleUrls: ['./user-listing.component.css']
})
export class UserListingComponent implements OnInit {
  userlisting: UserListingModel;
  pagingModel: PagingModel;
  Loader: boolean = false;
  userList: any;
  userResponseModel: UserResponseModel;
  totalPages: number;
  pageNumber: number = 1;
  searchValue: string = "";

  constructor(private localstorage: LocalstorageService, private _userService: UserService, config: NgbModalConfig, private modalService: NgbModal) {
    this.localstorage.setMenu("2");
    this.userlisting = new UserListingModel();
    this.userResponseModel = new UserResponseModel();
    this.pagingModel = new PagingModel();
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
  }

  ngOnInit() {
    this.userListing();
  }

  resetFilter() {
    this.searchValue = "";
    this.userlisting.PageNumber = 1;
    this.userlisting.PageSize = 10;
    this.totalPages = 1;
    this.pageNumber = 1;
    this.userListing();
  }

  filter() {
    this.userlisting.KeyWord = this.searchValue;
    this.userlisting.PageNumber = 1;
    this.userlisting.PageSize = 10;
    this.userListing();
  }

  userListing() {
    this.Loader = true;
    this.userlisting.KeyWord = this.searchValue;
    this._userService.userlisting(this.userlisting).subscribe(response => {
      this.Loader = false;
      this.userList = JSON.parse(response._body);
      if (this.userList.isSuccess) {
        this.userResponseModel.UserList = this.userList.responseData;
        this.userResponseModel.TotalPages = this.userList.totalPages;
        this.totalPages = this.userResponseModel.TotalPages == undefined ? 0 : this.userResponseModel.TotalPages;
      } (err) => {
        this.Loader = false;
      }
    });
  }

  loadPage(pagingModel: PagingModel) {
    this.userlisting.PageNumber = pagingModel.pageNumber;
    this.userlisting.PageSize = pagingModel.pageSize;
    this.userListing();
  }

  manageUserChangePassword(userDetail) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this._userService.passUserId(userDetail.id);
    this.modalService.open(ChangeUserPasswordComponent, modalConfig);
  }

  manageUserdetails(userDetail) {    
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "xl";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this._userService.passUserId(userDetail.id);
    let modalRef = this.modalService.open(UpdateUserComponent, modalConfig); 
    modalRef.result.then(() => {
    }, (reason) => {
      this.userListing();
    });  
  }
}
